<template>
 <div class="w-full overflow-y-auto">
  <div class="w-full max-w-[1160px] min-w-[463px] pt-[36px] px-[32px] flex flex-col mx-auto min-h-[100vh]">
      <!-- Header -->
      <div class="flex justify-between items-center">
        <span class="text-v-ui-text-monochrome title-24-medium-500">Шаблоны задач КЗС</span>
        <v-button type="primary" label="Добавить шаблон" @click="openAddPage" size="s" />
      </div>
      <!-- End Header -->
      <!-- Content -->
      <div class="mt-[24px] flex flex-col flex-1 min-h-0">
        <v-input
        v-model="searchString"
        placeholder="Введите ID или наименование шаблона"
        @input="onSearchInput"
        class="!h-[40px] templates-search-input"
        :leftIcon="{ name: 'search' }"
        variant="white"
        contentWidth
        />

        <div v-if="isError" class="mt-[40px] flex-1 min-h-0 flex">
          <v-placeholder
            message="Что-то пошло не так"
            description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
            :icon="{ name: 'xl/mood-confuzed' }"
            :retry="{ label: 'Повторить запрос', handler: fetchTemplatesList }"
            class="!min-h-[70vh] h-full w-full !p-[24px]"
          >
            <template #footer>
              <p class="text-14-reg-400">Позвонить в техподдержку</p>
              <a
                class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
                href="tel:88005000299"
                >8 800 500-02-99</a
              >
            </template>
          </v-placeholder>
        </div>


        <VPlaceholder v-else-if="totalCountInBase === 0 && !isFetching"
          message="Шаблонов ещё нет"
          :icon="{ name: 'xl/list-check' }"
          class="!min-h-[70vh] mt-[40px] flex-1"
        />

        <VPlaceholder v-else-if="searchString && totalCount === 0 && !isFetching"
          message="Шаблоны не найдены"
          :icon="{ name: 'xl/table-search' }"
          class="!min-h-[70vh] mt-[40px] flex-1"
        />

        <template v-else-if="isFetching" >
          <div class="flex flex-col rounded-[8px] bg-white border brd-accent-neutral-secondary mt-[40px] overflow-hidden">
            <div>
              <v-table-head :loading="true" />
              <v-table-line :loading="true" />
              <v-table-line :loading="true" />
              <v-table-line :loading="true" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="flex flex-col mt-[24px] pb-[55px]">
            <div class="flex gap-x-[8px] py-[16px]"> <span class="title-16-medium-500 text-heading-primary !leading-[24px]">Всего шаблонов</span> <v-badge type="light" size="m" :content="totalCount" /></div>
            <div class="rounded-[8px] bg-white border-[1px] brd-neutral-secondary min-w-[399px] max-w-[1096px]">
              <v-table-head  :cells="tableHeadCells" class="rounded-t-[8px]"/>
              <div v-for="(template, index) in templateList" :key="template.id">
                <v-table-line :cells="generateTableLineCells(template)" :type="index % 2 === 0 ? 'gray' : 'white'" />
              </div>
              <v-table-pagination
                v-if="totalCount > limit"
                :dark="true"
                isAutoDropDown
                :currentPage="page" :limit="limit"
                :total="totalCount"
                @update:currentPage="onChangePage"
                @update:limit="onChangeLimit"
              />
            </div>
          </div>
        </template>

      </div>
      <!-- End Content -->

      <VDialog
        v-model="isDeleteTemplateDialogOpen"
        title="Удаление шаблона задачи КЗС"
        subtitle="Вы хотите удалить шаблон? Это действие невозможно отменить."
        :leftButton='{"label":"Удалить", "handler": () => this.confirmDeleteTemplate()}'
        :rightButton='{"label":"Не удалять","closeOnClick":true}'
      />
    </div>
  </div>
</template>

<script>
import {
  VButton,
  VPlaceholder,
  VTableHead,
  VTableLine,
  VBadge,
  VTablePagination,
  VDialog,
  VInput,
} from '@gostelemed.front/rt-doctis.designsystem';

import kzsTemplateService from '@/services/kzs/kzs-templates/kzs-template.service';
import debounce from 'lodash/debounce';
import { TOASTS } from '@/services/core/ui/toasts.const';


export default {
  name: 'KzsTemplates',
  page: {
    title: 'CRM Doctis - Шаблоны задач КЗС',
  },
  components: {
    VButton,
    VInput,
    VPlaceholder,
    VTableHead,
    VTableLine,
    VBadge,
    VTablePagination,
    VDialog
  },
  data() {
    return {
      isDeleteTemplateDialogOpen: false,
      selectedTemplateId: null,
      searchString: '',
      templateList: null,
      isFirstFetch: true,
      page: 1,
      limit: 10,
      isFetching: true,
      isError: false,
      totalCount: 0,
      totalCountInBase: 0,
      tableHeadCells: [
      { title: "ID", class: 'max-w-[453px]' },
      { title: "Наименование", class: 'max-w-[453px]' },
      { title: "", class: 'max-w-[158px]' },
      ]
    }
  },

  async mounted() {
    await this.fetchTemplatesList();
  },

  created() {
    this.fetchDebouncedTemplatesList = debounce(this.fetchTemplatesList, 700);
  },

  methods: {
    onSearchInput() {
      this.page = 1;
      this.fetchDebouncedTemplatesList();
    },

    async fetchTemplatesList() {
      this.isFetching = true;
      try {
        if (this.isFirstFetch) {
        }
        const data = await kzsTemplateService.getKzsTemplateList({
          search: this.searchString,
          page: this.page,
          limit: this.limit,
        });
        this.templateList = data?.items;
        this.totalCount = data?.total;
        if (this.isFirstFetch) {
          this.totalCountInBase = data?.total;
          this.isFirstFetch = false;
        }
      } catch (error) {
        this.isError = true;
        console.error(error);
      } finally {
        this.isFetching = false;
      }
    },

    openAddPage() {
      this.$router.push('/remote-monitoring/kzs/templates/add');
    },

    generateTableLineCells(template) {
      return [
        {
          type: "iconWithText",
          text: template.id,
          class: 'max-w-[453px]'
        },
        {
          type: "iconWithText",
          text: template.name,
          class: 'max-w-[453px]'
        },
        {
          type: "actions",
          links: [
            {
              title: "Подробнее",
              href: `/remote-monitoring/kzs/templates/${template.id}`,
              target: "_self",
              spaMode: true,
              click: () => this.$router.push(`/remote-monitoring/kzs/templates/${template.id}`),
            },
          ],
          // icons: [
          //   {
          //     icon: "delet",
          //     type: "ghost",
          //     class: "!icon-warning-tertiary",
          //     handler: () => this.openDeleteTemplateDialog(template.id),
          //   },
          // ],
          class: 'max-w-[158px]'
        },
      ];
    },

    openDeleteTemplateDialog(id) {
      this.isDeleteTemplateDialogOpen = true;
      this.selectedTemplateId = id;
    },

    async confirmDeleteTemplate() {
      try {
        await kzsTemplateService.deleteKzsTemplate(this.selectedTemplateId);
        this.$uiService.showToast(TOASTS.KZS_TEMPLATE_DELETE_SUCCESS);
        this.isDeleteTemplateDialogOpen = false;
        this.selectedTemplateId = null;
        await this.fetchTemplatesList();
      } catch (error) {
        this.$uiService.showToast(TOASTS.KZS_EMPLATE_DELETE_ERROR);
        console.error(error);
      }
    },

    async onChangePage(page) {
       this.page = page;
       await this.fetchTemplatesList();
    },

    async onChangeLimit(limit) {
      this.limit = limit;
      this.page = 1;
      await this.fetchTemplatesList();
    },
  },
}
</script>

<style lang="scss">
.rtd-v-search__input {
  height: 40px !important;
}
</style>
